<template>

  <div class="container">

    <div class="row">

      <div class="col-12 offset-0 col-md-6 offset-md-3 text-center">

        <h3 class="mb-5 font-weight-light">Download your song</h3>

        <h4 class="mb-5 font-weight-light">{{ name }}</h4>

        <div v-if="links">
          <div  v-for="link in links" :key="link">
            <a class="btn btn-outline-success btn-lg mb-5 px-3" :href="link.url" download>{{ link.text }}</a>
          </div>
        </div>

      </div>

    </div>

  </div>

</template>

<script>

import axios from 'axios';

export default {
  name: 'Export',
  data() {
    return  {
      name: '',
      links: []
    }
  },
  methods: {
    loadData () {
      let token = this.$route.query.jwt;
      let songid = this.$route.query.songid;

      axios.get('https://trackd-v3-api.appspot.com/songexport-web/?jwt=' + token + '&songid=' + songid)
      .then(res => {
          this.name = res.data.name;
          this.links = res.data.links;
      })
      .catch(error => {
          this.name = 'Sorry something went wrong!';
          console.log(error)
      });

    }
  },
  beforeMount(){
      this.loadData()
   },
}
</script>
